<template>
  <span>
    <span v-if="unit.type == 'katex'">
      <span v-if="prefix != 'Tag/e' && prefix != 'Stunde/n' && prefix != 'Minute/n'" v-katex="prefix + ' ' + unit.content"></span>
      <span v-else v-katex="prefix"></span>
    </span>
    <span v-else v-html="prefix + unit.content"></span>
  </span>
</template>

<script>
export default {
  name: 'VariableUnitString',
  props: {
    unit: { type: Object, required: true },
    prefix: { type: String, default: '' }
  }
}
</script>
